import { createSelector } from 'reselect';
import { selectInstancePublishStatus, createInstanceValueSelector } from 'structured-content-lib/redux/selectors/instanceEditSelectors';
// @ts-expect-error not typed
import { getDataValidationErrors } from 'ContentEditorUI/redux/selectors/moduleErrorSelectors';
// @ts-expect-error not typed
import { getErrorLabels } from 'ContentEditorUI/utils/validationUtils';
import { basicSelector } from 'ContentEditorUI/redux/selectors/helpers';
import { selectPublishValidationErrors } from 'structured-content-lib/redux/selectors/publishSelectors';
import { hasPublisherPermission } from 'case-study-lib/utils/auth';
export const selectPublishedAt = createInstanceValueSelector('hs_published_at');
export const selectIsInstancePublished = createSelector([selectPublishedAt, selectInstancePublishStatus], (hasPublishedAtValue, publishStatus) => !!hasPublishedAtValue && publishStatus !== 'DRAFT');
export const selectButtonTextKey = createSelector([selectIsInstancePublished], isPublished => {
  const hasPermissionToPublish = hasPublisherPermission();
  if (hasPermissionToPublish) {
    // The following lang keys are defined in CEUI and are intended
    // to be shared across editors for consistency
    if (isPublished) {
      return 'header.publishButton.update.label';
    }
    return 'header.publishButton.publish.label';
  } else {
    return 'header.publishButton.notAuthorized.label';
  }
});
const selectArticleErrorsAndWarnings = createSelector([getDataValidationErrors, selectPublishValidationErrors, hasPublisherPermission], (moduleDataValidationErrors, publishingErrors, publishPermission) => {
  const errors = Object.assign({}, moduleDataValidationErrors, publishingErrors);
  if (!publishPermission) {
    errors['userHasNoPublishAccess'] = {
      pane: 'publishing',
      type: 'userHasNoPublishAccess'
    };
  }
  return {
    errors,
    warnings: {
      /* ...settings warnings */
    }
  };
});
export const selectInstanceErrorLabels = createSelector(selectArticleErrorsAndWarnings, ({
  errors
}) => getErrorLabels(errors));
export const selectInstanceWarningLabels = createSelector(selectArticleErrorsAndWarnings, ({
  warnings
}) => getErrorLabels(warnings));
export const selectBaseModalSettings = basicSelector(state => state.baseModalSettings);
export const selectScrollToElement = createSelector([selectBaseModalSettings], settings => settings.scrollToElement);